module.exports = __webpack_public_path__ + "img/feature-two.e89fa316.svg";